import { atu, core } from '@/api/api-endpoints'
import L from 'leaflet'
import { COLORS } from '@/utils'

const TYPES = {
  not_allowed: 'not_allowed',
}
export default {
  data() {
    return {
      types: [],
      zones: [],
      zoneDefaultNumber: 1,
      fields: {
        tkoActions: [],
      },
    }
  },
  computed: {
    notAllowedTypes() {
      return this.types.filter((item) => item.category_id === TYPES.not_allowed)
    },
    allowedTypes() {
      return this.types.filter((item) => item.category_id !== TYPES.not_allowed)
    },
    notAllowedZones() {
      const notAllowedTypeIds = this.notAllowedTypes.map((item) => item.id)
      return this.zones.filter((item) =>
        notAllowedTypeIds.includes(item.type_id)
      )
    },
    allowedZones() {
      const allowedTypeIds = this.allowedTypes.map((item) => item.id)
      return this.zones.filter((item) => allowedTypeIds.includes(item.type_id))
    },
  },
  methods: {
    isAllowedZone(item) {
      const allowedTypeIds = this.allowedTypes.map((item) => item.id)
      return allowedTypeIds.includes(item.type_id)
    },
    async getTypes() {
      this.types = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('geo_sanitary_zone_type'),
        })
      ).data.geo_sanitary_zone_type
    },
    async getZones() {
      this.zones = []
      this.fields.tkoActions = []
      if (this.editableLayers) {
        this.editableLayers.clearLayers()
      }
      this.zones = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.sanitaryZone(),
        })
      ).data.data
      this.zones.sort((a, b) => {
        return a.id - b.id
      })
      this.zoneDefaultNumber = this.zones[this.zones.length - 1]?.id + 1
      this.zones.forEach((item) => {
        setTimeout(() => {
          let coords = item.geometry.coordinates[0]
          coords = coords.map((item) => {
            return [item[1], item[0]]
          })
          const isAllowedZone = this.isAllowedZone(item)
          const color = isAllowedZone ? COLORS.green : COLORS.red
          const polygon = L.polygon(coords, {
            stroke: true,
            color,
            weight: 2,
            fillColor: color,
            fillOpacity: 0.2,
            opacity: 0.5,
            clickable: true,
            dashArray: null,
            dashOffset: null,
          })
          item.leaflet_id = this.editableLayers.getLayerId(polygon)
          this.editableLayers.addLayer(polygon)
          if (this.hasEditableZones && this.addPopupToZones) {
            this.addPopupToZones(item, polygon)
          }
        }, 200)
      })
    },
  },
  mounted() {
    this.getTypes()
  },
}
